import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskChecklistWrite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-checklist-write" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,6.749v-1.5a1.5,1.5,0,0,0-1.5-1.5h-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.25,3.749h-4a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5H6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.421,4.736a.751.751,0,0,1-.711.513H7.291a.751.751,0,0,1-.712-.513l-1-3A.749.749,0,0,1,6.291.749h8.418a.749.749,0,0,1,.712.987Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.75,20.249H4.5a.75.75,0,0,1-.75-.75V6.749"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.752,
			y1: 7.499,
			x2: 15.752,
			y2: 9.749
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 9.749,
			x2: 11.25,
			y2: 9.749
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 14.249,
			x2: 8.25,
			y2: 14.249
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.045,22.719l-3.712.53.53-3.712,9.546-9.546a2.25,2.25,0,0,1,3.182,3.182Z"
		})
	]
});
export default SvgTaskChecklistWrite;
